import { R } from '@core/utils/r';
import { Endpoint } from '../endpoint';
import { FormResponse, FormId, CompactFormResponse } from '@business/entities/form';
import { FileResponse } from '@business/entities/file';
import { OrgId } from '@business/entities/organization';
import { CustomTabFormResponse } from '@business/entities/custom-tab';

export function fetchForms(fullResponse: boolean) {
  const params = R.objectCompact({ fullResponse });
  return Endpoint.get<CompactFormResponse[]>(`@gc/subcontractor-form`, { params });
}
export function fetchTabForm() {
  return Endpoint.get<CustomTabFormResponse[]>(`@gc/custom-tabs/tab-form`);
}

export function fetchForm(id: FormId) {
  return Endpoint.get<FormResponse>(`@gc/subcontractor-form/form/${id}`);
}

export function createForm(data: Partial<FormResponse>) {
  return Endpoint.post<FormResponse>(`@gc/subcontractor-form`, { data });
}

export function updateForm(id: FormId, data: Partial<FormResponse>) {
  return Endpoint.patch<FormResponse>(`@gc/subcontractor-form/${id}`, { data });
}

export function deleteForm(id: FormId) {
  return Endpoint.delete<void>(`@gc/subcontractor-form/${id}`);
}

export function duplicateForm(id: FormId, data: Partial<FormResponse>) {
  return Endpoint.post<FormResponse>(`@gc/subcontractor-form/duplicate/${id}`, { data });
}

export function saveFormFields(id: FormId, data: Pick<FormResponse, 'fields'>) {
  return Endpoint.post<FormResponse>(`@gc/subcontractor-form/save-fields/${id}`, { data });
}

export function deleteFormShare(id: string) {
  return Endpoint.delete<void>(`@gc/subcontractor-form/delete-share/${id}`);
}

export function getOrgFileForms(orgId: OrgId) {
  return Endpoint.get<FileResponse[]>(`@gc/subcontractor-form/org-file-subcontractor-form/${orgId}`);
}
